const steps = [
  {
    num: "01",
    title: "무료 상담 신청",
    desc: "간단한 정보 입력 후, 전담 애널리스트가 투자 성향과 관심 분야를 파악하기 위한 1:1 사전 상담을 진행합니다.",
    time: "1일 이내",
  },
  {
    num: "02",
    title: "투자 진단 · 전략 수립",
    desc: "현재 보유 포트폴리오와 리스크 성향을 진단하고, 목표 수익률에 맞춘 맞춤형 투자 전략을 설계합니다.",
    time: "2~3일",
  },
  {
    num: "03",
    title: "시그널 · 리포트 제공",
    desc: "매일 마켓 브리핑, 주간 종목 분석, 실시간 투자 시그널을 회원 전용 플랫폼을 통해 제공합니다.",
    time: "지속 제공",
  },
  {
    num: "04",
    title: "정기 리뷰 · 전략 고도화",
    desc: "월간 성과 리뷰와 분기 전략 세미나를 통해 시장 변화에 맞춰 투자 전략을 지속적으로 업데이트합니다.",
    time: "월간/분기",
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-background-100 py-20 md:py-32 border-y border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl">
          <div className="text-xs md:text-sm tracking-widest text-primary-500 font-semibold mb-4">
            OUR PROCESS
          </div>
          <h2 className="font-heading font-black text-3xl md:text-5xl text-foreground-50 leading-tight tracking-tight">
            가입부터 투자 집행까지,
            <br />
            <span className="text-gold-gradient">네 단계로 완성</span>
          </h2>
          <div className="gold-divider w-16 my-8"></div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.num}
              className="relative bg-background-50 border border-background-300/50 rounded-lg p-6 md:p-8"
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="font-heading font-black text-4xl md:text-5xl text-gold-gradient">
                  {s.num}
                </span>
                {i < steps.length - 1 && (
                  <i className="ri-arrow-right-line text-primary-500 text-xl hidden lg:block"></i>
                )}
              </div>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-50">
                {s.title}
              </h3>
              <p className="text-sm text-foreground-300 leading-relaxed mt-3">{s.desc}</p>
              <div className="mt-6 pt-4 border-t border-background-300/60 flex items-center gap-2 text-xs text-primary-500">
                <i className="ri-time-line"></i>
                <span>{s.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}